import isEqual from 'lodash.isequal'

import { Controller } from '@hotwired/stimulus'
// import get from 'lodash.get'
// import { getDisplayValues } from '../helpers/computedValues'
// import { connectUserData, getFlow } from '../helpers/controllerHelpers/utils'
import { hasUrlParam, isBuilderEditingMode } from '../helpers/utils'
import { connectUserData, getFlow } from '../helpers/controllerHelpers/utils'
import { Context, UserData, OptionSelector } from '../api/models/types'
import { handleRequest } from '../api/handleRequest'

const CONTROLLER_OPTIONS_SELECTOR = 'components--option-selector'

export default class extends Controller {
  static values = {
    repeaterKey: String,
    repeaterValue: Array,
    url: String,
    pageId: String,
    componentId: String,
    component: Object,
  }

  declare fetchIndex: number
  declare userDataValue: UserData
  declare repeaterValueValue: unknown
  declare readonly componentValue: OptionSelector
  declare readonly componentIdValue: string
  declare readonly repeaterKeyValue: string
  declare readonly pageIdValue: string
  disconnectUserData: (() => void) | undefined
  flowIdValue: string | null | undefined
  declare urlValue: string | null | undefined
  groupIdValue: any
  declare optionSelectorController: any

  connect() {
    const flowEl = this.element.closest(`[data-controller*="flow"]`)
    this.flowIdValue = flowEl?.getAttribute('data-flow-id-value')
    this.urlValue = flowEl?.getAttribute('data-flow-url-value')

    this.disconnectUserData = connectUserData(this, this.userDataValueChanged)
    this.userDataValueChanged()

    this.optionSelectorController = (this.application.getControllerForElementAndIdentifier(
      this.element,
      'components--option-selector'
    ) as any) || { optionTargets: [] }
  }

  disconnect() {
    if (typeof this.disconnectUserData === 'function') this.disconnectUserData()
  }

  repeaterKeyValueChanged() {
    this.userDataValue && this.updateComponent()
  }

  userDataValueChanged() {
    this.updateComponent()
  }

  updateComponent() {
    let repeaterValue = this.userDataValue[this.repeaterKeyValue]
    if (!this.urlValue || !this.pageIdValue || !Array.isArray(repeaterValue)) return

    repeaterValue = repeaterValue.map((button) => ({
      ...button,
      is_repeatable_button: true,
    }))

    // @TODO: Use always_rerender here like in repeatable_controller.ts
    if (isEqual(this.repeaterValueValue, repeaterValue)) return

    this.repeaterValueValue = repeaterValue

    // const qsAddons = (this.qsValueValue && this.qsValueValue.split('&')) || []
    const baseUrl = `${this.urlValue}/page/${this.pageIdValue}/component/${this.componentIdValue}`
    // if (this.versionValue) qsAddons.push(`version=${this.versionValue}`)

    // const qs = qsAddons.length ? `?${qsAddons.join('&')}` : ''
    // const url = `${baseUrl}${qs}`
    let url = `${baseUrl}`
    if (isBuilderEditingMode() && !hasUrlParam('savvy_editing', 'no_sidebar'))
      url += '?savvy_editing=true'

    this.fetchIndex = (this.fetchIndex || 0) + 1
    let localIndex = this.fetchIndex
    const context: Context = {
      env: 'local',
      fetch: (...args) => fetch(args[0], args[1]),
      flowsBucket: {},
    }
    const flow = getFlow(this, true)
    const body = {
      json: {
        flowId: this.flowIdValue,
        groupId:
          this.element
            .closest('[data-flow-group-id-value]')
            ?.getAttribute('data-flow-group-id-value') || '',
        component: {
          ...this.componentValue,
          buttons: this.repeaterValueValue,
        },
        flow,
        page: {
          ...flow.pages.find((p) => p.id === this.userDataValue.current_page_id),
          key: this.userDataValue.current_page_key,
          id: this.userDataValue.current_page_id,
        },
      },
    }

    const requestURL = new URL(url)
    const headers = new Headers()
    const request = {
      url: requestURL,
      method: 'POST',
      headers,
      body,
    }
    handleRequest(context, request)
      .then((res) => {
        return res.responseData
      })
      .then((componentHtml) => {
        if (localIndex !== this.fetchIndex) return
        const tempEl = document.createElement('div')
        tempEl.innerHTML = componentHtml
        this.element.innerHTML = (tempEl?.firstChild as HTMLElement)?.innerHTML

        this.triggerOnButtonsRepeatableRenderActions()

        const targetsByValue = this.optionSelectorController.optionTargets.reduce((acc, el) => {
          const valueKey = el.getAttribute(`data-${CONTROLLER_OPTIONS_SELECTOR}-value-param`)
          acc[String(valueKey)] = el
          return acc
        }, {})

        const isAdvancedDropdown =
          this.element.getAttribute('data-components--option-selector-advanced-dropdown-value') ===
          'true'
        if (isAdvancedDropdown) {
          this.optionSelectorController.addListenerDataListCloseOnAnyClick()
          this.optionSelectorController.addResizeObservers()

          const searchable =
            this.element.getAttribute('data-components--option-selector-searchable-value') ===
            'true'
          if (searchable) {
            this.optionSelectorController.updateSearchInputDisplayValue({
              userData: this.userDataValue,
            })
          } else {
            this.optionSelectorController.updateSpanDisplayValue({
              userData: this.userDataValue,
            })
          }
        }

        const key = this.element.getAttribute('data-component-key-value')
        let newValue = key && (this.userDataValue[key] as any)

        if (newValue) {
          if (Array.isArray(newValue)) {
            // this.selectOptionAttributes(newValue.map((val) => targetsByValue[val]).filter((t) => t))
            // if (this.dropdownValue) this.updateTagsList(newValue, targetsByValue)
          } else if (targetsByValue[newValue]) {
            this.selectOptionAttributes([targetsByValue[newValue]])
          }
        }
      })

    // if (!this.textValue) return
    // if (this.textValue === 'undefined') return

    // const userData = {
    //   ...this.userDataValue,
    //   _display_values: getDisplayValues(this.userDataValue, getFlow(this)),
    // }

    // const text = this.textValue
    //   .split('{{')
    //   .map((a, i) => {
    //     return i === 0 ? a : get(userData, a.split('}}')[0] || '') + a.split('}}')[1]
    //   })
    //   .join('')

    // if (this.currentText === text) return
    // this.currentText = text
    // this.element.innerHTML = text
  }

  selectOptionAttributes(
    optionEls: {
      innerText: string
      classList: { add: (arg0: string) => void }
      setAttribute: (arg0: string, arg1: string) => void
      querySelectorAll: (arg0: string) => any[]
    }[]
  ) {
    optionEls.forEach((optionEl) => {
      optionEl.classList.add(this.optionSelectorController.selectedClass)
      optionEl.setAttribute('selected', 'selected')
      optionEl.querySelectorAll('.Checkbox').forEach((el) => {
        el.classList.add('selected')
        el.setAttribute('data-controller', 'icon')
      })
    })
  }

  triggerOnButtonsRepeatableRenderActions() {
    //* I trigger onrender actions after updating the innerHTML of the element
    if (this.componentValue.outputs_onbuttonsrepeatablerender) {
      const actions = this.componentValue.outputs_onbuttonsrepeatablerender

      this.dispatch('actions', {
        detail: {
          actions: actions,
          component: this.componentValue,
        },
      })
    }
  }
}
